import {
    Button,
    Col,
    Form,
    Modal,
    Input,
    Row,
    Table,
    Select,
    message,
    Radio,
    Space,
    DatePicker,
    Tooltip,
} from 'antd'
import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import _ from 'lodash'
import { Dialog } from 'primereact/dialog'
import NumberForm from './NumberForm'
import { bizNumbersService } from '../../_services'

export default function CompanyMobile() {
    function getDefaultQuery(query) {
        const dto = {}
        dto.page = query.page || 1
        dto.pageSize = query.pageSize || 20
        return dto
    }

    const [defaultQuery] = useState(getDefaultQuery({}))

    const [query, setQuery] = useState(defaultQuery)

    const [tableParams, setTableParams] = useState({
        pagination: {
            current: 1,
            pageSize: 10,
        },
    })

    const [data, setData] = useState({
        list: [],
        pagination: {
            page: 1,
            pageSize: 20,
            total: 0,
        },
    })

    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRecord, setSelectedRecord] = useState()
    const [modalActionType, setModalActionType] = useState('')
    const [btnStatus, setBtnStatus] = useState(true)

    const [loading, setLoading] = useState(false)
    useEffect(() => {
        let isCurrent = true
        setLoading(true)

        bizNumbersService
            .getBizNumbers()
            .then(res => {
                if (isCurrent) {
                    let obj = {}
                    obj.list = res.data
                    obj.pagination = {
                        total: res.length,
                        page: query.page,
                        pageSize: query.pageSize,
                    }
                    setData(obj)
                }
            })
            .finally(() => isCurrent && setLoading(false))

        bizNumbersService.getActiveBizNumber().then(res => {

            if(_.isArray(res.data) && res.data.length !== 0){
                const activeNumber = _.first(res.data)
                setSelectedRowKeys([activeNumber.activeNumberID])
            } else {
                setSelectedRowKeys([0])
            }
        
        })

        return () => {
            isCurrent = false
        }
    }, [query])

    function handleDelete(record, onSuccess) {
        Modal.confirm({
            title: 'Delete Roster',
            content: <p>Are you sure to delete selected record?</p>,
            onOk: async () => {
                try {
                    await bizNumbersService.removeBizNumberById(record.id)

                    message.success('Sucessfully deleted')
                    onSuccess()
                } catch (e) {
                    message.error('Delete unsuccessful')
                }
            },
        })
    }
    function clamp(value, min, max) {
        return Math.min(Math.max(value, min), max)
    }

    function newNumber() {
        setModalActionType('create')
    }

    const clearActiveNumber = async () => {
        await bizNumbersService.updateActiveBizNumber([0])
        refreshTable()
    }

    const clean = () => {
        setSelectedRecord(undefined)
        setBtnStatus(true)
    }
    const handleModalCancel = () => {
        setModalActionType('')
        clean()
    }

    const refreshTable = options => {
        setQuery(prev => Object.assign({}, prev))
        setBtnStatus(true)
    }

    const updateActiveBizNumber = async data => {
        await bizNumbersService.updateActiveBizNumber(data)
    }

    const columns = [
        { dataIndex: 'id', title: 'id' },
        { dataIndex: 'name', title: 'name' },
        { dataIndex: 'mobile', title: 'mobile' },
        // { dataIndex: 'active', title: 'active' },
        {
            title: 'Actions',
            render: (_, record) => (
                <Space>
                    <span
                        style={{ cursor: 'pointer' }}
                        className="text-primary"
                        onClick={() => {
                            setSelectedRecord(record)
                            setModalActionType('update')
                        }}
                    >
                        Edit
                    </span>
                    <span
                        style={{ color: 'red', cursor: 'pointer' }}
                        className="text-danger"
                        onClick={() =>
                            handleDelete(record, () => {
                                setBtnStatus(true)
                                setQuery(prev => {
                                    const prevPage = prev.page || 1
                                    return Object.assign(
                                        Object.assign({}, prev),
                                        {
                                            page:
                                                data.list.length === 1
                                                    ? clamp(
                                                          prevPage - 1,
                                                          1,
                                                          prevPage
                                                      )
                                                    : prevPage,
                                        }
                                    )
                                })
                            })
                        }
                    >
                        Delete
                    </span>
                </Space>
            ),
        },
    ]
    return (
        <div>
            <div style={{ margin: '15px 0' }}>
                <Space>
                    <Button type="primary" onClick={newNumber}>
                        Add Number
                    </Button>
                    <Button type="primary" onClick={clearActiveNumber}>
                        Clear
                    </Button>
                </Space>
            </div>
            <Table
                rowKey="id"
                dataSource={data.list}
                loading={loading}
                columns={columns}
                rowSelection={{
                    type: 'radio',
                    selectedRowKeys: selectedRowKeys,
                    renderCell(checked, record, index, node) {
                        // if (record.PayrollEmpRosterStatus) {
                        //     return (
                        //         <Tooltip title="Approved">{node}</Tooltip>
                        //     )
                        // }
                        return node
                    },
                    onChange: (_, row) => {
                        setSelectedRecord(row)
                        setBtnStatus(false)
                        setSelectedRowKeys(row.map(r => r.id))
                        updateActiveBizNumber(row.map(r => r.id))
                    },
                }}
            ></Table>

            <Dialog
                header="Create"
                visible={modalActionType === 'create'}
                // footer={renderFooter('displayBasic')}
                onHide={handleModalCancel}
                maximized={false}
                maximizable={true}
                resizable={true}
                breakpoints={{ '960px': '75vw', '640px': '100vw' }}
                style={{ width: '50vw' }}
            >
                <NumberForm
                    handleClose={handleModalCancel}
                    onSubmitRefresh={refreshTable}
                />
            </Dialog>
            <Dialog
                header="Update"
                visible={modalActionType === 'update'}
                // footer={renderFooter('displayBasic')}
                onHide={handleModalCancel}
                maximized={false}
                maximizable={true}
                resizable={true}
                breakpoints={{ '960px': '75vw', '640px': '100vw' }}
                style={{ width: '50vw' }}
            >
                <NumberForm
                    handleClose={handleModalCancel}
                    data={selectedRecord}
                    onSubmitRefresh={refreshTable}
                />
            </Dialog>
        </div>
    )
}
